import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DataViewFiltersComponent } from '@shared/components/data-view/filters/data-view-filters.component';

@Component({
  selector: 'app-data-map-filters',
  templateUrl: './data-map-filters.component.html',
  styleUrl: './data-view-filters.component.scss',
  // TODO(onpush): inherits from DataViewFiltersComponent (out of scope for this migration), whose setFilters()/addFilter()
  // mutate template-visible fields (appliedFilters, activeFilter, isOffcanvasOpen, filterOptionsLoaded, showClearAll) from
  // async subscribe callbacks (e.g. offcanvas.hidden) and a setTimeout, outside any OnPush-recognized trigger for this
  // subclass. Cannot safely instrument without modifying the shared base class.
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DataMapFiltersComponent extends DataViewFiltersComponent {}
